module.exports = __webpack_public_path__ + "static/media/Banner.b870fe66.png";